import { isDevEnv } from "utils/Utils";

/** Alle norske målepunkt-ID-er starter med dette. */
export const MAALEPUNKT_ID_PREFIX = "7070575000";

/**
 * Målepunkt-ID (GSRN) er 18 siffer som starter på 7070575000, der det siste er et GS1-kontrollsiffer (modulus 10,
 * vekt 3 og 1 fra høyre). Kontrollsifferet fanger skrivefeil og ID-er Excel har rundet av, som 707057500000000123
 * vist som 707057500000000000.
 */
export function isValidMaalepunktId(value: string): boolean {
	if (isDevEnv()) return true;
	if (!/^\d{18}$/.test(value) || !value.startsWith(MAALEPUNKT_ID_PREFIX)) return false;
	const sum = [...value.slice(0, 17)].reverse().reduce((acc, digit, i) => acc + Number(digit) * (i % 2 === 0 ? 3 : 1), 0);
	return (10 - (sum % 10)) % 10 === Number(value[17]);
}
